export const NUMERIC_ID = /^\d+$/;

export const toServerId = (value) => (NUMERIC_ID.test(value) ? value : "");

export const resolveApiBrowseFilters = ({
  status,
  orderId,
  transactionType,
}) => ({
  ...(status ? { status } : {}),
  ...(orderId ? { orderId } : {}),
  ...(transactionType ? { transactionType } : {}),
});

/** Empty clears; full numeric commits; invalid input keeps the existing server filter. */
export const resolveCommittedOrderId = (input, committedOrderId) => {
  const trimmed = input.trim();
  if (!trimmed) return "";
  const serverId = toServerId(trimmed);
  return serverId || committedOrderId;
};
